<template>
  <div class="supply">
    <div class="supply-type">
      <p>Type：</p>
      <span v-for="(item,index) in typeList" :key="index" :class="activeIndex == index ? 'active' : ''" @click="select(item,index)" >{{item}}</span>
    </div>
    <div class="supply_pro_name" v-if="type=='Supply'&&userRole.toUpperCase() == 'EXHIBITOR'">
      <!-- 输入任意文本 -->
      <van-field
        readonly
        clickable
        name="picker"
        :value="checkPro"
        label="Product："
        placeholder="Select a product"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="proList"
          confirm-button-text="Ok"
          cancel-button-text="Cancel"
          @confirm="onConfirm"
          :default-index="defaultIndex"
          value-key="name"
          @cancel="showPicker = false"
        />
      </van-popup>
      <!-- <van-field v-model="proName" placeholder="请输入产品名称" label="产品名称：" /> -->
      <!-- <p>产品名称：</p>
      <input type="text"> -->
    </div>
    <div class="supply_pro_name" v-else>
      <van-field v-model="proName" placeholder="Please add a product name" label="Product：" />
    </div>
    <div class="edit_supply_warp">
      <van-field
        class="edit_supply_textarea"
        v-model="content"
        type="textarea"
        placeholder="Please add content"
        @input="fieldChange"
        maxlength="800"
        rows="4"
        show-word-limit
      />
      <div class="uploading_wrap" :class="fileType=='video'?'video_up':''">
        <van-uploader
          v-model="fileList"
          multiple
          :accept="typeAccept"
          :max-count="fileType=='video'?1:5"
          :before-read="beforeRead"
          :after-read="afterRead"
          @delete="deleteimg"
          :preview-size="size"
        >
          <!--          <img src="@assets/img/empty.png" >-->
          <template #preview-cover=" file " >
            <div class="preview-cover" v-if="file&&file.cover">
              <div class="video_wrap" >
                <videoPlayer :cover="file.cover" :url="file.url" ></videoPlayer>
                <!-- <img :src="file.cover" alt=""> -->
              </div>
              <!-- <div class="img_w" v-else>
                <img :src="file.url" v-load="'oPic'" alt="">
              </div> -->
              <!-- <div class="play_mask">
                <i class="iconfont icon-zhibo"></i>
              </div> -->
            </div>
          </template>
        </van-uploader>
      </div>
      <span style="color:#bfbfbf;">5 pictures or 1 video at most</span>
      <div class="btn-bg">
        <div class="btn" @click="submitRelease" v-if='isFinish'>
          <span>Submit</span>
        </div>
         <div class="btn def-btn" v-else> 
          <span>Submit</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import OSS from "ali-oss";
import * as ObsClient from "esdk-obs-browserjs";
import { mapGetters, mapActions, mapState } from "vuex";
import videoPlayer from "./component/videoPlayer";
import config from "../../../static/config.json";
export default {
  name: "editSupply",
  components: {
    videoPlayer
  },
  data() {
    return {
      content: "",
      isNotPreview: false,
      isMy: false,
      fileList: [],
      Upimg: [], // 上传的图片
      fileType:'all', 
      size: "2.14rem",
      supplyDemand:{},
      typeList:['Purchase','Supply'],
      activeIndex:0,
      proName:'',
      checkPro:'',
      type:'Purchase',
      defaultIndex:0,
      showPicker:false,
      proList:[],
      upFinish:0,
      isFinish:true,
      video:'', //上传的视频
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId: "getExhibitionId",
      userRole: 'getUserRole',
    }),
    editId(){
      return this.$route.query.editId||false
    },
    typeAccept(){
      return this.fileType=='all'?'image/*,video/*':(this.fileType=='image'?'image/*':'video/*')
    }
  },
  created() {
    if(this.userRole.toUpperCase() == 'EXHIBITOR'&&this.userInfo.inMember.exhibitorId){
      this.getProList();
    }
    if(this.editId){
      this.$toast.loading('loading...')
      this.getSupply();
    }
    this.$Myapollo.addExhibitionView();
  },
  methods: {
    ...mapActions({
      supplyDemandSubmit: "topicSupply/supplyDemand",
      editSupply:'topicSupply/editSupply',
      graphqlPost: "en/graphqlPostByZXS",
    }),
    onConfirm(pro){
      this.checkPro=pro.name;
      this.showPicker=false;
    },
    fieldChange(e) {
      this.content = e; 
      // localStorage.setItem("content",this.content)
    },
    select(item,index){
       if(item=='Supply'&this.userRole.toUpperCase() != 'EXHIBITOR'){
        this.$toast.fail('Only exhibitors can post supply information')
        return 
      }
      this.activeIndex = index;
      this.type = item;
    },
    getSupply(){
      let query=gql `query
      supplyDemand($id: Guid!){
          supplyDemand(id:$id){
            imgUrls
            content
            imgUrls
            originName
            productName
            type
            id
            videos
          }
      }`
      this.$apollo.addSmartQuery("supplyDemand",{ 
        query:query,
        variables:{
          id:this.editId
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          let res=JSON.parse(JSON.stringify(data.data.supplyDemand));
          // let res=data.data.queryProduct;
         this.content=res.content;
         let imgArr=[]
         this.fileType='all';
         let imgJson=[];
         if(res.imgUrls){
            imgArr=res.imgUrls.split(';');
            this.fileType='image'
            imgArr.map(el=>{
              imgJson.push({url:el});
            })
         }else if(res.videos&&JSON.parse(res.videos)[0].url){
            let video=JSON.parse(res.videos)[0];
            imgArr=[{
              url:video.url,
              cover:video.cover
            }];
            imgJson=imgArr;
            this.video=video.url;
            this.fileType='video'
         }
         this.fileList=imgJson
         if(this.fileType=='image'){
           this.Upimg=this.fileList;
         }
         this.typeList.forEach((e,i)=> {
            if(e==res.type){
              this.activeIndex=i;
              this.type=res.type
            }
         });
        if(res.type=='Supply'){
          this.checkPro=res.productName;
              this.proList.forEach((e,i)=>{
                if(e.name==res.productName){
                  this.defaultIndex=i;
                }
              })
          }else{
            this.proName=res.productName;
          }
         this.$toast.clear();
        },
        error(err){
          console.log('err',err)
        }
      })
    },
    // 发布供需-讨论
    async submitRelease() {
      if (!this.content) {
        this.$toast.fail("Please add content");
        return;
      }
      if (!this.proName&&!this.checkPro) {
        this.$toast.fail("Please add a product name");
        return;
      }
      // if (/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.content)) {
      //   this.$toast.fail("不能包含手机号");
      //   return;
      // }
      let imgUrls=[];
      let videos='';
      if (this.Upimg&&this.Upimg.length) {
        this.Upimg.map((el) => {
          imgUrls.push(el.url);
        });
      }else if(this.video){
        videos=`[{"cover":"${this.video}?x-oss-process=video/snapshot,t_5000,f_jpg,w_0,h_0,m_fast","url":"${this.video}","duration":"","coverIndex": 5}]`
      }
      if(!this.editId){
        let opt = {
          memberId: this.userInfo.id,
          content: this.content,
          publisherType: 0,
          originName: this.isMy ? this.exhibitionInfo.name : "平台",
          exhibitionId: this.exhibitionId,
          type:this.type,
          langVersion:'en',
          productName:this.proName
        };
        if(this.type=='Supply'){
          opt.productName=this.checkPro;
        }
        if (this.Upimg.length) {
          opt.imgUrls = imgUrls.join(";");
        }else if(this.video){
          opt.videos=videos
        }
        // console.log(opt,imgUrls,'imgUrls')
        let data = await this.supplyDemandSubmit(opt);
        if (data && data.result) {
          this.$toast.success({
            message:"Success",
            forbidClick:true,
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        } else {
          this.$toast.fail("Fail");
        }
      }else{
        let opt={
          id:this.editId,
          content:this.content,
          type:this.type,
          productName:this.proName,
          auditState:0
        }
        if(this.type=='Supply'){
          opt.productName=this.checkPro;
        }
        if (this.Upimg&&this.Upimg.length) {
          opt.imgUrls = imgUrls.join(";");
          opt.videos=''
        }else if(this.video){
          opt.videos=videos;
          opt.imgUrls=''
        }else{
          opt.imgUrls=''
          opt.videos=''
        }
        let res= await this.editSupply(opt);
        if(res.result){
          this.$toast.success({
            message:"Successfully submitted",
            forbidClick:true,
          });
          setTimeout(() => {
            this.$router.go(-1);
          }, 500);
        }else{
          this.$toast.fail("failed to submit");
        }
      }
    },
    async getProList(){
      let query=`
        query($where:String!){
          productQuery{
            getList(where:$where){
              id
              name
            }
          }
        }
      `
      let where = {
        Equal: {
          n: "exhibitorId",
          v: this.userInfo.inMember.exhibitorId,
        },
        EqualB: {
          n: "auditState",
          v: 1,
        },
        Equal_lang: {
          n: "langVersion",
          v: "en",
        },
        Equal_isD: {
          n: "isDeleted",
          v: 0,
        },
      };
      let opt={
        query: query,
        variables: {
          where:JSON.stringify(where)
        }
      };
      let data=await this.graphqlPost(opt);
      let res=JSON.parse(
        JSON.stringify(data.data.productQuery.getList)
      );
      this.proList=res;
    },
    viewImg(e) {
      this.isNotPreview = true;
      let imgL = this.imgList;
      imgL = imgL.map((c) => {
        return (c += this.oPotoView);
      });
    },
    deleteimg(index) {
      console.log(index, "index");
      console.log(this.fileList, "fileList");
      if (index.url) {
        this.Upimg = this.fileList;
      }
      if(!this.fileList.length){
        this.fileType='all'
      }
      console.log(index, "index");
    },
    getUpFileType(file){
      let haveImage=false;
      let haveVideo=false;
      file.forEach(e=>{
        if(e.type.includes('video')){
          haveVideo=true
        }
        if(e.type.includes('image')){
          haveImage=true;
        }
      })
      if(haveImage&&haveVideo){
        return 'all'
      }else if(haveImage){
        return 'image'
      }else if(haveVideo){
        return 'video'
      }else {
        return 'error'
      }
    },
    // 返回布尔值
    beforeRead(file) {
      console.log(file,'上传图片')
      if(Array.isArray(file)){ // 多张图片
      if(this.fileList&&this.fileList.length){
          if(this.fileType!=this.getUpFileType(file)){
            this.$toast.fail("Pictures and videos cannot be uploaded at the same time");
            return false
          }
        }
        let isTrue = true;
        for(var i=0; i<file.length; i++){
          if(!(file[i].type === "image/jpeg" || file[i].type === "image/png" ||file[i].type.includes('video'))){
            this.$toast.fail("The picture or video is not in the right format");
            isTrue = false;
            break;
          }
          if(file[i].size > 1024 * 10000 * 10){
            this.$toast.fail("The picture or video cannot exceed 100M");
            isTrue = false;
            break;
          }
        }
        return isTrue;
      } else {
        if(this.fileList&&this.fileList.length){
          if(!file.type.includes(this.fileType)){
            this.$toast.fail("Pictures and videos cannot be uploaded at the same time");
            return false
          }
        }
        const isJPG = file.type === "image/jpeg" || file.type === "image/png" || file.type.includes('video');
        if (!isJPG) {
          this.$toast.fail("The picture or video is not in the right format");
          return false;
        }
  
        if (file.size > 1024 * 10000 * 10) {
          //图片不能超过4M
          this.$toast.fail("The picture or video cannot exceed 100M");
          return false;
        }
        return true;
      }
    },
    getImgOrVideo(file,isType=false){
      let fileData={
        type:'video',
        arr:[],
      }
      for (let i = 0; i < file.length; i++) {
        if(file[i].file){
          if(file[i].file.type.includes('image')){
            fileData.type='image';
            break 
          }
        }else{
          if(file[i].type.includes('image')){
            fileData.type='image';
            break 
          }
        }
      }
      if(isType){
        return fileData.type
      }
      file.forEach(e=>{
        if(e.file.type.includes(fileData.type)){
          fileData.arr.push(e);
        }
      })
      return fileData
    },
    // 上传完成，上传至服务器
    afterRead(file) {
      console.log(file, "上传完成");
      this.$toast.loading({
        message: "loading...",
        forbidClick: true,
        duration: 0,
      });
      this.isFinish = false;
      this.upFinish = 0;
      if(Array.isArray(file)){ // 多张图片
      let fileJson=this.getImgOrVideo(file);
         if(fileJson.type=='image'){
          for(let i=0; i<fileJson.arr.length; i++){
            this.upFileImg(fileJson.arr[i],fileJson.arr.length);
          }
        }else{
          this.upFileVideo(fileJson.arr[0].file)
          //上传视频 上传第一个
        }
      } else {
        if(file.file.type.includes('image')){
          this.upFileImg(file,1);
        }else{
          this.upFileVideo(file.file)
        }
      }
      // console.log(file, "上传完成");
      // this.$toast.loading({
      //   message: "上传中...",
      //   forbidClick: true,
      //   duration: 0,
      // });
      // let data = new FormData();
      // data.append("multfile", file.file);
      // data.append("operaType", null);
      // // this.$dialog.loading.open();
      // this.$http
      //   .post("https://online-api.zhanshangxiu.com/api/v1/file", data)
      //   .then((res) => {
      //     // this.Upimg.push(res.data.Data.imgUrls[0])
      //     console.log(res);
      //     if (res.data.data) {
      //       this.fileList = [];
      //       let opt = {
      //         url: res.data.data[0],
      //       };
      //       this.Upimg.push(opt);

      //       this.Upimg.map((el) => {
      //         this.fileList.push(el);
      //       });

      //       this.show = false;
      //       this.$toast.clear();
      //     }
      //   })
      //   .catch((err) => {
      //     this.$toast.fail("上传失败了！");
      //     this.$toast.clear();
      //   });
    },
    videoName(str) {
      // 返回随机视频名 /exshow/videos/年月/时间戳+5位随机数.mp4
      const year = new Date().getFullYear();
      var month = new Date().getMonth();
      const time = new Date().getTime();
      if (month < 9) {
        month = "0" + (month + 1);
      } else {
        month = month + 1;
      }
      const prefix = "/showonline/video";
      const random = this.randomn(5);
      const name = `${prefix}/${year}${month}/${time}${random}.${str}`;
      return name;
    },
    randomn(n) {
      // 返回随机数 n是取值几位数
      let res = "";
      for (
        ;
        res.length < n;
        res += Math.random()
          .toString(36)
          .substr(2)
          .toUpperCase()
      ) {}
      return res.substr(0, n);
    },
    upFileVideo(file) {
      if (config.https.uploadType === "obs") {
        this.upVideo2(file);
      } else {
        this.upVideo(file);
      }
    },
    upVideo(file) {
      const str = file.name.split(".")[1];
      let client = new OSS({
        region: "cn-shanghai",
        accessKeyId: "LTAI5tHdipkqKVNJmDJ6vaJ4",
        accessKeySecret: "9tu7VxQ7iBFDFO79BCoK8nGbIZKqSO",
        endpoint: "oss-cn-shanghai.aliyuncs.com",
        bucket: "huizhanren",
      });
      let that = this;
      const storeAs = this.videoName(str);
      client
        .multipartUpload(storeAs, file, {})
        .then(function(result) {
          console.log(result, "result-----");
          const url = result.res.requestUrls[0].split("?")[0];
          console.log(url, "url");
          if (url) {
            that.fileType='video'
            that.fileList=[];
            that.fileList[0]={
              url:url,
              cover:`${url}?x-oss-process=video/snapshot,t_5000,f_jpg,w_0,h_0,m_fast`
            }
            that.video=url;
            // that.video = url;
            that.isFinish = true;
            that.$toast.clear();
          }
        })
        .catch(function(err) {
          console.log(err, "上传失败");
          that.$toast.clear();
          that.$toast.fail("failed to upload");
        });
      // }
    },
     upVideo2(file) {
      const str = file.name.split(".")[1];
      let obsClient = new ObsClient({
        access_key_id: "PFD508XIWCMWIONTAAD1",
        secret_access_key:  "4RF8ZQyYsTYT5wxF9P0xtmu8QcUQHzl9rYP3b5Kg",
        server: "https://obs.cn-north-4.myhuaweicloud.com",
      });
      let that = this;
      let storeAs = this.videoName(str);
      storeAs = storeAs.replace("/", "");
      obsClient.putObject(
        {
          Bucket: "synairsoft",
          Key: storeAs, // 存储在obs的文件。可写成file/name即会生成file文件夹name文件
          SourceFile: file, // 文件上传使用sourceFile文本上传采用Body
          // ACL: true, // 如果设置ACL即为公共访问。不需要认证如果不设置此项ACL，则需要先通过文件下载在进行路径访问
        },
        function(err, result) {
          console.log(result, "result-----");
          if (err) {
            console.error("Error-->", err);
            console.log(err, "上传失败");
            that.$toast.clear();
            that.$toast.fail("failed to upload");
          } else {
            const url = "https://synairsoft.obs.cn-north-4.myhuaweicloud.com/" + storeAs;
            if (url) {
              that.fileType = "video";
              that.fileList = [];
              that.fileList[0] = {
                url: url,
                cover: `${url}?x-oss-process=video/snapshot,t_5000,f_jpg,w_0,h_0,m_fast`,
              };
              that.video = url;
              that.isFinish = true;
              that.$toast.clear();
            }
          }
        }
      );
    },
    upFileImg(file,length){
      let data = new FormData();
      data.append("multfile", file.file);
      data.append("operaType", null);
      // this.$dialog.loading.open();
      this.$http
        .post("https://online-api.zhanshangxiu.com/api/v1/file", data)
        .then((res) => {
          // this.Upimg.push(res.data.Data.imgUrls[0])
          console.log(res,'upFie');
          if (res.data.data) {
            this.fileList = [];
            let opt = {
              url: res.data.data[0],
            };
            this.Upimg.push(opt);
            this.Upimg.map((el) => {
              this.fileList.push(el);
            });
            this.upFinish = this.upFinish + 1;
            console.log(this.upFinish,length,'所有图片数量')
            if(this.upFinish == length) {
              // this.show = false;
              this.fileType='image'
              this.$toast.clear();
              this.isFinish = true;
              console.log('所有图片上传完成')
            }
          }
        })
        .catch((err) => {
          this.upFinish = this.upFinish + 1;
          this.$toast.clear();
          this.$toast.fail("failed to upload!");
      }); 
    },
  },
};
</script>

<style lang="scss" scoped>
.supply {
  width: 100%;
  background-color: #f5f5f5;
  min-height: 100vh;
  &-type{
    padding: .24rem;
    margin-bottom: .2rem;
    background: #fff;
    p{
      display: inline-block;
      font-size: .26rem;
      color: #333;
    }
    span{
      padding: 0 0.2rem;
      height: .48rem;
      border-radius: .05rem;
      border: solid 1px #ccc;
      text-align: center;
      line-height: .48rem;
      display: inline-block;
      font-size: .26rem;
      color: #666;
      margin-right: .2rem;
    }
    .active{
      color: #fff;
      background: #ff5e00;
      border: solid 1px #ff5e00;
    }
  }
  .supply_pro_name{
    margin-bottom: 0.2rem;
    background: #fff;
    ::v-deep .van-field{
      padding: 0.24rem;
      .van-cell__title{
        width: 1.35rem;
        span{
          font-size: 0.26rem;
        }
      }
    }
  }
}
.edit_supply_warp {
  padding: 0 0.24rem 0.24rem;
  color: #fff;
  background: #fff;
  .van-cell {
    padding: 0.25rem 0 0.1rem;
    margin-bottom: 0.5rem;
    border-radius: 3px;
    background: #fff;
    overflow-y: initial;
    &::after {
      display: none;
    }
    .van-field__input {
      min-height: 1.3rem;
      color: #333;
    }
    .van-field__word-limit {
      color: #bfbfbf;
    }
    // &::v-deep .van-cell__value{
    //   .van-field__control{
    //     line-height: 0.28rem;
    //     color: #fff;
    //     word-break:break-all;
    //     word-wrap:break-word;
    //     text-align: justify;
    //   }
    // }
  }
  .uploading_wrap {
    display: flex;
    margin-bottom: 0.2rem;
    flex-wrap: wrap;
    &.video_up{
      width: 100%;
      ::v-deep .van-uploader__wrapper{
        width: 100%;
        .van-uploader__preview{
          margin: 0;
          width: 100%;
          .van-uploader__file{
            height: 4.2rem!important;
            width: calc(100vw - 0.48rem)!important;
          }
        }
      }
    }
    ::v-deep .van-uploader__preview-delete{
      z-index: 3;
    }
    .preview-cover{
      width: 100%;
      height: 100%;
      background: rgba($color: #000, $alpha: 0.3);
      .img_w{
        width: 100%;
        height: 100%;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .video_wrap{
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 1;
        img{
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .play_mask{
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba($color: #000, $alpha: 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          .iconfont{
            font-size: 0.64rem;
            color: #fff;
          }
        }
    }
    .img_block {
      margin-right: 0.2rem;
      position: relative;
      &:nth-child(3) {
        margin-right: 0;
      }
      .img_wrap {
        width: 2.14rem;
        height: 2.14rem;
        border-radius: 1px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          // object-fit: cover;
        }
      }
      .van-icon {
        background: transparent;
        font-size: 0.35rem;
        top: -0.12rem;
        right: -0.12rem;
        color: #fff;
      }
    }
    .img_uploading {
      .van-uploader__upload-icon {
        font-size: 0.3rem;
      }
      .van-image__img {
        width: 2.14rem;
        height: 2.14rem;
      }
      margin: 0;
      border: 1px #ccc dashed;
      display: flex;
      justify-content: center;
      width: 2.14rem;
      height: 2.14rem;
      background-color: #f2f2f2;
      border-radius: 0.1rem;
    }
    .van-icon-clear {
      font-size: 0.3rem;
      position: absolute;
      top: 0;
      right: 0;
      font-size: 0.3rem;
      margin-right: -0.15rem;
      margin-top: -0.15rem;
      color: #666666;
    }
  }
}
.select-topic {
  height: 0.88rem;
  width: 100%;
  margin-top: 0.3rem;
  background-color: #fff;
  span {
    line-height: 0.88rem;
    font-size: 0.3rem;
  }
  &-box {
    padding: 0 0.3rem;
    display: flex;
    position: relative;
    align-items: center;
    .span1 {
      color: #ff5c00;
      font-weight: bold;
      display: inline-block;
      margin-right: 0.2rem;
    }
  }
  &-list {
    padding: 0 0.3rem;
    display: flex;
    position: relative;
    align-items: center;
    .lspan {
      color: #ff5c00;
      font-weight: bold;
      display: inline-block;
      margin-right: 0.2rem;
    }
  }
}
.topic-tips {
  margin-right: 0.2rem;
  height: 0.48rem;
  display: flex;
  align-items: center;
  border-radius: 0.24rem;
  background-color: #ffddcc;
  .span-tips-1 {
    padding: 0.14rem 0.2rem;
    font-size: 0.22rem;
    color: #ff5500;
  }
  .span-tips-2 {
    color: #ff5500;
    font-size: 0.22rem;
    margin-left: 0.1rem;
  }
}
.scroll_view {
  overflow: auto;
  white-space: nowrap;
  width: 6rem;
  position: relative;
}
.trans {
  position: absolute;
  width: 0.6rem;
  height: 0.88rem;
  right: 0.7rem;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
}
.btn-bg {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 0;
  right: 0;
  height: 0.98rem;
  width: 100%;
  text-align: center;
}
.btn {
  width: 6.5rem;
  height: 0.78rem;
  background-color: #1890ff;
  border-radius: 0.37rem;
  border: solid 2px #1890ff;
  margin: 0 auto;
  margin-top: 0.1rem;
  span {
    color: #fff;
    font-size: 0.3rem;
    line-height: 0.78rem;
  }
}
.def-btn{
  background-color: #ccc;
  border: solid 2px #ccc;
}
</style>
